import { Button, Text } from "@chakra-ui/react";
import React from "react";

interface CyberIdButtonProps {
  onClick: () => void;
  isLoading?: boolean;
}

/** Przycisk „Zaloguj przez CyberID" — biały, w stylu przycisku społecznościowego (mirror CyberspaceButton). */
export const CyberIdButton: React.FC<CyberIdButtonProps> = ({ onClick, isLoading }) => (
  <Button
    onClick={onClick}
    isLoading={isLoading}
    variant="outline"
    w="100%"
    h="auto"
    py="13px"
    bg="white"
    borderColor="rgba(61,10,112,0.25)"
    borderRadius="12px"
    transition="all 0.15s"
    _hover={{ bg: "rgba(61,10,112,0.05)", borderColor: "rgba(61,10,112,0.55)" }}
    _active={{ bg: "rgba(61,10,112,0.09)" }}
  >
    <Text fontSize="15px" fontWeight="700" color="primary">
      Zaloguj przez{" "}
      <Text as="span" color="accent">
        CyberID
      </Text>
    </Text>
  </Button>
);
